import { render } from "./Edit.vue?vue&type=template&id=64ee0bc2"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import "./Edit.vue?vue&type=style&index=0&id=64ee0bc2&lang=css"

import exportComponent from "/var/www/app/resources/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__